import React from "react";
import { setMode } from "../../store/componentsSlice";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import Radio, { RadioType } from "./inputs/radio";
import OptionBar from "./optionBar";

export type Mode = "light" | "dark" | "auto";

const modes = [
  { value: "light", label: "Light Mode", icon: "light_mode" },
  { value: "dark", label: "Dark Mode", icon: "dark_mode" },
  { value: "auto", label: "Auto", tooltip: "Device Theme", fitlabel: true },
];

function DarkModeToggle() {
  const dispatch = useAppDispatch();
  const mode = useAppSelector((state) => state.components.mode);

  function handleModeChange(event: React.ChangeEvent<HTMLInputElement>) {
    dispatch(setMode(event.target.value as Mode));
  }

  return (
    <OptionBar
      compact
      dynamic
      data-length="autofit"
      data-height="auto"
      data-palette="lighter"
    >
      {modes.map((m) => (
        <Radio
          value={mode}
          key={m.value}
          icon={m.icon}
          radioType={RadioType.Button}
          radioValue={m.value}
          label={m.label}
          onChange={handleModeChange}
          tooltip={m.tooltip}
          fitLabel={m.fitlabel}
        />
      ))}
    </OptionBar>
  );
}

export default DarkModeToggle;
